import * as React from 'react';
import styled from 'styled-components';

export const InnerContainer = styled.div`
  border-radius: 10px;
  border: 1px solid var(--color-separator);
  flex: 1;
  background-color: var(--color-surface-1);
  overflow: hidden;

  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Container = styled.div`
  margin: 0px 10px 10px 10px;
  flex: 1;
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const ListControlContainer = (props: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}): React.ReactElement => {
  return (
    <Container style={props.style}>
      <InnerContainer>{props.children}</InnerContainer>
    </Container>
  );
};
